module.exports = __webpack_public_path__ + "static/media/econometric.36283fda.jpeg";